import {
    TimePicker,
    TimePickerProps,
} from '@progress/kendo-react-dateinputs'

import { classNames } from 'utils/dom-helpers'

export function TimeInput(props: TimePickerProps) {
    return (
        <TimePicker
            {...props}
            disabled={props.disabled || false}
            className={classNames(
                'focus:ring-primary-light focus:border-primary-light w-full shadow-sm border-gray-300 rounded-md h-10 calendar text-xs text-inherit flex items-center font-medium'
            )}
            onChange={props.onChange}
            // dateInput={CustomTimeInputGroup}
            defaultValue={props.defaultValue}
        />
    )
}

export default TimeInput
